import { render, staticRenderFns } from "./IngressiDetails.vue?vue&type=template&id=0f60bdb8&scoped=true"
import script from "./IngressiDetails.vue?vue&type=script&lang=js"
export * from "./IngressiDetails.vue?vue&type=script&lang=js"
import style0 from "./IngressiDetails.vue?vue&type=style&index=0&id=0f60bdb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f60bdb8",
  null
  
)

export default component.exports